module.exports = __webpack_public_path__ + "img/qrcode.0b80e35.svg";